import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCasesEntity, patchCasesEntity, postCasesEntity } from "./thunks";
import { CasesEntity } from "../../../entities/cases_v2";

interface CasesEntityState {
  loading: boolean,
  saveLoading: boolean,
  entity?: CasesEntity,
}

const initialState: CasesEntityState = {
  loading: false,
  saveLoading: false,
}

const saveCasesEntity = (
  builder: ActionReducerMapBuilder<CasesEntityState>,
  action: any
) => {
  builder.addCase(action.pending, (state: CasesEntityState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: CasesEntityState, action: PayloadAction<CasesEntity>) => {
    state.saveLoading = false;
    state.entity = action.payload;
  });
  builder.addCase(action.rejected, (state: CasesEntityState) => {
    state.saveLoading = false;
  });
};

export const casesEntityStore = createSlice({
  name: "casesEntity",
  initialState: initialState,
  reducers: {
    clearEntity: (state) => {
      state.entity = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCasesEntity.pending, state => {
      state.loading = true;
    })
    builder.addCase(getCasesEntity.fulfilled, (state, action) => {
      state.entity = action.payload;

      state.loading = false;
    })
    const saveActions = [patchCasesEntity,
      postCasesEntity];

    saveActions.forEach((action) => { saveCasesEntity(builder, action) })
  },
})

export const { clearEntity } = casesEntityStore.actions

export default casesEntityStore.reducer